module.exports = __webpack_public_path__ + "static/media/view1.d64aec9b.jpg";